import { useEffect, useState } from 'react';

function useWindowSize(): number {
  const [width, setWidth] = useState(window.innerWidth);

  function updateWindowDimensions() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, [width]);

  return width;
}

export default useWindowSize;
